export type MaterialSymbolOutline =
  | 'add'
  | 'assignment'
  | 'broadcast_on_personal'
  | 'description'
  | 'history'
  | 'package_2'
  | 'report'
  | 'service_toolbox'
  | 'shopping_cart'
  | 'speed'
  | 'swap_vert';
export const MATERIAL_SYMBOLS_OUTLINED_ICONS: MaterialSymbolOutline[] = [
  'add',
  'assignment',
  'broadcast_on_personal',
  'description',
  'history',
  'package_2',
  'report',
  'service_toolbox',
  'shopping_cart',
  'speed',
  'swap_vert',
];
